<template>
  <div class="about">
    <div id="title">
        <h1>關於金石</h1>
    </div> 
    <div class="container">
        <h2>金石建設秉持在地深耕、永續經營、誠信踏實的理念。我們特別注重建築結構安全，別人用5分鋼筋，我們就用7分鋼筋，地基全採用大樓結構筏式基礎施工。對於客戶的承諾我們說到做到，地段開發、格局規劃、建材品質、外觀審美，全方位要求完美。作品一出，往往短時間內即銷售一空。</h2>
        <ul class="list">
            <li>金石建築品質獲得國際ISO品質認證</li>
            <li>柯金龍董事長榮膺第五、六屆建築公會<br>理事長</li>
            <li>柯建利總經理榮膺第十屆嘉義市不動產公會<br>候補監事</li>
            <li>柯建利總經理榮獲華人公益節-公益大使</li>
            <li>金石建設榮獲.國家建築金質獎</li>
        </ul>
    </div>
    <div class="btn">
      <button class="seemore"><a><router-link to='/AboutUS'>看更多</router-link></a></button>
    </div>
  </div>
  
</template>
 
<script>
export default {
  data(){
    return {     
      }
  }
}
</script>
<style scoped>
.about{
  width: 100%;
  height: auto;
  margin:3% 0;
}

#title h1{
  text-align: center;
  margin: 0% auto 12% auto;
  width: 100%;
  height: auto;
  padding: 1% 0;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.93px;
  color: #a89a80;
}

.container{
  width: 90%;
  height: auto;
  margin:  5% auto 5% auto;
  text-align:center;
  /* background-image: linear-gradient(to top, #c4c3c230 41%, #dadad93a 60%, #feffff79 100%); */
}
h2 {
  width: 86%;
  height: auto;
  margin: 2% auto;
  font-size: 13.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: 1.07px;
  text-align: justify;
  color: #7d7d7d;
}

@keyframes showupnews{
    0%{
      transform: translateY(12px);
    }
    100% {
        opacity: 1;
        }
    }
.list{
  width: 80%;
  height: auto;
  font-size: 11.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: 1.07px;
  text-align: justify;
  color: #d0ad76;
  list-style-type: circle;
  margin-left: 5.5px;
  margin-top: 20px;
}

.btn{
  width:100%;
  height: auto;
  margin: 12% auto 0% auto;
  text-align:center;
}

.seemore {
  text-align:center;
  width: auto;
  height: auto;
  padding: 1% 5%;
  margin: 0 auto;
  border: solid 1px rgba(196, 182, 156, 0.521);
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #BDAA87;
  background: transparent;
}
.seemore a{
  text-decoration:none;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #BDAA87;
  }

.seemore:active {
  text-align:center;
  width: auto;
  height: auto;
  padding: 1% 5%;
  margin: 0 auto;
  border: solid 0.5px #BDAA87;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #BDAA87;
  background: #BDAA87;
}
.seemore a:active{
  text-decoration:none;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #ffffff;
  }
</style>